module.exports = __webpack_public_path__ + "assets/img/063a31e0fa1dcab8ba0f18015b4ca8d3.png";